<script lang="ts" setup>
import type { Toast } from '@/plugins/toast/types'

const open = defineModel<boolean>({ required: true })

const props = defineProps<{
    toast: Toast
}>()

const emit = defineEmits(['closed'])

const model = computed({
    get: () => open.value,
    set: (value) => {
        open.value = value
        if (!value) {
            emit('closed')
        }
    },
})

const icon = computed(() => {
    switch (props.toast.type) {
        case 'error':
            return {
                name: 'mdi-alert',
                color: 'error-lighten-1',
            }
        case 'info':
            return {
                name: 'mdi-information',
                color: 'info-lighten-1',
            }
        case 'success':
            return {
                name: 'mdi-check',
                color: 'success-lighten-1',
            }
        default:
            return
    }
})

const timeout = computed(() => {
    switch (props.toast.autoclose) {
        case true:
            return 5000
        case false:
            return -1
        default:
            return props.toast.autoclose
    }
})

const iconSize = 24
</script>
<template>
    <VSnackbar
        v-model="model"
        :timeout
        multi-line
        location="bottom right"
        min-width="0"
        color="neutral-900"
    >
        <div class="d-flex ga-2 align-center">
            <div>
                <VProgressCircular
                    v-if="props.toast.type === 'loading'"
                    :size="iconSize"
                />
                <VIcon
                    v-if="icon"
                    :icon="icon.name"
                    :color="icon.color"
                    :size="iconSize"
                >
                    {{ icon.name }}
                </VIcon>
            </div>
            <div>
                <p v-if="props.toast.title" class="mb-2 font-weight-bold">
                    {{ props.toast.title }}
                </p>
                <p v-if="props.toast.message">
                    {{ props.toast.message }}
                </p>
            </div>
        </div>
    </VSnackbar>
</template>
